//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vr_tip from '../img_preview/mixin/vr_tip'
import audio from '../img_preview/mixin/audio'
import ImgTools from '../img_preview/_img_tools'
import AudioPlayer from '../img_preview/_audio_player'
import VrTip from '../img_preview/_vr_tip'
export default {
    data() {
        return {
            vr_link: ''
        }
    },
    computed: {
        decorate_type_title () {
            return this.detail.show_decorate_price === 0 ? '清水' : this.detail.decoration_type
        },
        show_disclaimer () {
            return this.detail.building.activities && this.detail.building.activities.indexOf('vr_disclaimer') > -1
        }
    },
    mixins: [
        vr_tip,
        audio
    ],
    components: {
        ImgTools,
        AudioPlayer,
        VrTip
    },
    props: {
        detail: {
            type: Object
        }
    },
    methods: {
        getOpenVr() {
            const { id, name } = this.detail.building
            const detailParam = encodeURIComponent(`building_id=${id}`)
            const vr_link = `/building/web_vr?building_id=${id}&link=${encodeURIComponent(this.detail.layout_image.vr_url)}&title=${name}&detailParam=${detailParam}&category_id=${this.detail.layout_image.id}`
            this.openVr(vr_link)
        },
        goLoanComputer () {
            this.$router.push({
                path: `/packageA/loan_computer/main?total_price=${this.detail.total_price}`
            })
        },
        showDecoraterSelect () {
            if (this.detail.show_decorate_select && this.detail.show_decorate_price) {
                this.$emit('showDecoraterSelect')
            }
        },
        previewImg() {
            const current = this.detail.layout_image.image_url
            wx.previewImage({
                current,
                urls: [current]
            })
        },
        goLayout(layout_id) {
            const { id } = this.detail.building
            this.$router.push({
                path:`/building/layout_detail?building_id=${id}&layout_id=${layout_id}`
            })
        },
        goVideo () {
            const { id, name } = this.detail.building
            const src = this.detail.layout_image.video_url
            this.$router.push({
                path:`/building/video?building_id=${id}&title=${name}&src=${src}`
            })
        },
        play () {
            this.playAudio(0, this.detail.layout_image.audio_url)
        },
        stop () {
            this.stopAudio(0)
        },
        seek (percent) {
            this.seekAudio(percent)
        },
    }
}
